import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, stopPropagation, Thunder, TS_DialogOverlay, TS_MemoryMonitor, TS_Notifications, TS_PopUp, TS_ToastOverlay, TS_ToolTip } from '@nu-art/thunderstorm-frontend/index';
import './App.scss';
import { TS_FloatingWindows } from '@nu-art/floating-windows';
import { LoginComponent } from './pages/Page_Main/LoginComponent.js';
import { DiscussionsView } from '@app/org-frontend';
export class App extends ComponentSync {
    __onSessionUpdated() {
        this.forceUpdate();
    }
    static blockEvent(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }
    getAdditionalOverlayRenderer(overlay, overlayIndex) {
        const Renderer = overlay;
        return _jsx(Renderer, {}, overlayIndex);
    }
    deriveStateFromProps(nextProps) {
        return {};
    }
    render() {
        // @ts-ignore
        const blockRightClick = !Thunder.getInstance().config.isDebug;
        return (_jsxs("div", { id: "app", onDrop: stopPropagation, onDragOver: stopPropagation, onContextMenu: blockRightClick ? stopPropagation : undefined, children: [_jsx(LoginComponent, { rootRoute: this.props.rootRoute }), _jsx(TS_DialogOverlay, {}), _jsx(TS_FloatingWindows, {}), _jsx(TS_PopUp, {}), _jsx(TS_ToolTip, {}), _jsx(TS_ToastOverlay, {}), _jsx(DiscussionsView, {}), _jsx(TS_Notifications, {}), _jsx(TS_MemoryMonitor, {}), this.props.additionalOverlays?.map((Overlay, index) => this.getAdditionalOverlayRenderer(Overlay, index))] }));
    }
}
